export default __webpack_public_path__ + "static/media/Transparent_Image_1.e5ee05a1.png";